<template>
    <div>
        <DRow>
            <DCol>
                <DTabs class="mb-3">
                    <DTabItem
                        id="lov-country-layout-country"
                        :route-url="$route('settings.countries.show', { country: country.country_code })"
                        :active="['settings.countries.show'].includes($route().current())"
                        :label="__('settings.countries.country')"
                    />
                    <DTabItem
                        id="lov-country-layout-states"
                        :route-url="$route('settings.countries.states.index', { country: country.country_code })"
                        :active="['settings.countries.states.index'].includes($route().current())"
                        :label="__('settings.countries.states.title')"
                    />
                </DTabs>
            </DCol>
        </DRow>

        <slot />
    </div>
</template>

<script setup>
defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
})
</script>
